import { StatsUnit } from "../model";

/**
 * Hours saved, from seconds: whole hours from 10 hours, one decimal below that (COMBI-4629).
 */
export function formatHours(seconds: number, lang: string): string {
  const hours = seconds / 3600;
  return new Intl.NumberFormat(lang, {maximumFractionDigits: hours < 10 ? 1 : 0}).format(hours);
}

export function unitKey(unit: StatsUnit | "NONE", count: number): string {
  return `PAGE_DASHBOARD_TIMESAVED_UNIT_${unit}_${count === 1 ? 'ONE' : 'MANY'}`;
}
